module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/387.e59a722e.png";